"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const EditIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9434 2.70711C16.5529 2.31658 15.9197 2.31658 15.5292 2.70711L14.115 4.12132L17.6505 7.65685L19.0648 6.24264C19.4553 5.85212 19.4553 5.21895 19.0648 4.82843L16.9434 2.70711ZM16.2363 9.07107L12.7008 5.53553L5.05062 13.1857C4.96791 13.2684 4.91682 13.3775 4.90623 13.494L4.62339 16.6053C4.59512 16.9162 4.85563 17.1767 5.1666 17.1485L8.27787 16.8656C8.39436 16.855 8.50345 16.8039 8.58616 16.7212L16.2363 9.07107Z" }),
    react_1.default.createElement("rect", { x: "3", y: "20", width: "19", height: "2" })));
exports.EditIcon = EditIcon;
exports.default = exports.EditIcon;
